import { Outlet, ScrollRestoration } from 'react-router-dom';

export function PageRoot() {
  return (
    <div style={{ isolation: 'isolate' }}>
      <ScrollRestoration />
      <Outlet />
      {/* <PosthogPageView /> */}
    </div>
  );
}
